import { render } from "./CardChallengeResultItemIncomplete.vue?vue&type=template&id=2fe6e7e3&scoped=true"
import script from "./CardChallengeResultItemIncomplete.vue?vue&type=script&lang=js"
export * from "./CardChallengeResultItemIncomplete.vue?vue&type=script&lang=js"

import "@/css/components/card-challenge-result-item-incomplete.css?vue&type=style&index=0&id=2fe6e7e3&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe6e7e3"]])

export default __exports__